import { useAuthService, useAuthState } from '@vis-auth/react';
import React, { useState } from 'react';

/* eslint-disable camelcase */
var mockTokenKey = 'fake-auth-token';
var defaultDevToolOptions = {
    displayName: 'Default User',
    token: {
        user: {
            user_id: '123',
            account_id: '321',
            roles: ['GENERAL'],
        },
        idp_claims: {
            claim1: 'value1',
            fakeauth: true,
        },
    },
};
function setFakeAuthCookie(tokenContents) {
    var json = JSON.parse(tokenContents);
    if (json.idp_claims) {
        json.idp_claims.fakeauth = true;
    }
    else {
        Object.assign(json, {
            idp_claims: {
                fakeauth: true,
            },
        });
    }
    var jsonString = JSON.stringify(json);
    var base64String = btoa("" + jsonString);
    var cookieTTL = new Date();
    cookieTTL.setTime(cookieTTL.getTime() + 1 * 60 * 1000); // in milliseconds
    document.cookie = mockTokenKey + "=" + base64String + ";expires=" + cookieTTL.toUTCString() + ";path=/";
}
function deleteFakeAuthToken() {
    document.cookie = mockTokenKey + "=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;Path=/;";
}

/* eslint-disable camelcase */
var FakeLogin = function (_a) {
    var _b = _a.mockAuthOptions, mockAuthOptions = _b === void 0 ? [] : _b;
    var authService = useAuthService();
    var _c = useState(JSON.stringify(defaultDevToolOptions.token, null, 2)), tokenContents = _c[0], setTokenContents = _c[1];
    var onSelectUser = function (event) {
        var selectedUserId = event.target.value;
        var selectedUser = mockAuthOptions.find(function (mockAuthOption) { return mockAuthOption.token.user.user_id === selectedUserId; }) ||
            defaultDevToolOptions;
        setTokenContents(JSON.stringify(selectedUser.token, null, 2));
    };
    var fakeLogin = function (event) {
        event.preventDefault();
        setFakeAuthCookie(tokenContents);
        authService.authorizeRedirect();
    };
    return (React.createElement("form", { className: "usa-form", onSubmit: fakeLogin },
        mockAuthOptions.length > 0 && (React.createElement("div", { "data-testid": "users-select" },
            React.createElement("label", { htmlFor: "user-options", className: "usa-label" }, "Select User:"),
            React.createElement("select", { id: "user-options", onChange: onSelectUser, className: "usa-select" },
                React.createElement("option", { key: 0, value: defaultDevToolOptions.token.user.user_id }, defaultDevToolOptions.displayName),
                mockAuthOptions.map(function (mockAuthOption) {
                    return (React.createElement("option", { key: mockAuthOption.token.user.user_id, value: mockAuthOption.token.user.user_id }, mockAuthOption.displayName));
                })))),
        React.createElement("div", null,
            React.createElement("label", { htmlFor: "token-contents", className: "usa-label" }, "Token Contents:"),
            React.createElement("textarea", { id: "token-contents", "data-testid": "token-contents", value: tokenContents, onChange: function (e) { return setTokenContents(e.target.value); }, style: { display: 'block', minHeight: '16rem', minWidth: '18rem' }, className: "usa-textarea" }),
            React.createElement("button", { type: "button", className: "usa-button usa-button--outline usa-button--inverse ver-button", onClick: function () { return setTokenContents(JSON.stringify(JSON.parse(tokenContents), null, 2)); } }, "Format JSON"),
            React.createElement("button", { type: "submit", className: "usa-button usa-button--accent-cool ver-button" }, "Fake Login"),
            React.createElement("hr", { className: "margin-y-4" }))));
};

/* eslint-disable jsx-a11y/label-has-associated-control */
var AccessToken = function () {
    var accessToken = useAuthState().accessToken;
    return accessToken ? (React.createElement("div", { "data-testid": "access-token-content" },
        React.createElement("p", null,
            "Access Token: ",
            accessToken),
        React.createElement("button", { type: "button", className: "usa-button", onClick: function () {
                return navigator.clipboard.writeText(accessToken);
            } }, "Copy to clipboard"))) : null;
};
var Devtools = function (_a) {
    var _b = _a.initialOpen, initialOpen = _b === void 0 ? false : _b, mockAuthOptions = _a.mockAuthOptions;
    var _c = useState(initialOpen), open = _c[0], setOpen = _c[1];
    if (!open) {
        return (React.createElement("div", { style: {
                position: 'fixed',
                left: '1rem',
                bottom: '1rem',
            } },
            React.createElement("button", { "data-testid": "open-devtools-button", type: "button", onClick: function () { return setOpen(true); }, style: {
                    border: '2px solid black',
                    fontSize: '1.6rem',
                    borderRadius: '2rem',
                    height: '3rem',
                    width: '3rem',
                    overflow: 'hidden',
                } },
                React.createElement("span", { role: "img", "aria-label": "Devtools" }, "\uD83D\uDD11"))));
    }
    return (React.createElement("div", { "data-testid": "fake-auth-content", style: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            background: 'black',
            color: 'white',
            textAlign: 'initial',
            padding: '1rem',
        } },
        React.createElement("div", null,
            React.createElement("h1", null, "Devtools"),
            React.createElement("button", { "data-testid": "close-devtools-button", type: "button", onClick: function () { return setOpen(false); }, className: "usa-button", style: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1rem',
                } }, "Close")),
        React.createElement(FakeLogin, { mockAuthOptions: mockAuthOptions }),
        React.createElement(AccessToken, null)));
};

export { Devtools, FakeLogin, defaultDevToolOptions, deleteFakeAuthToken, setFakeAuthCookie };
//# sourceMappingURL=index.es.js.map
